import {
    bexHttpClient
} from '../../clients';
import {
    ConfigServiceName,
    GetOrganizationConfigResponse,
    UpdateOrganizationConfigResponse,
} from '../bexService.types';
import {
    AxiosResponse
} from 'axios';

/**
 * Service class for performing secret keys operations.
 */
class SecretKeysService {
    /**
     * Get organization configuration details for a specific service type.
     * @param {string} organizationId - The organization ID.
     * @param {ConfigServiceName} type - The service type (elasticsearch, redis, or milvus).
     * @returns {Promise<GetOrganizationConfigResponse>} The response containing configuration details.
     */
    async getConfigDetails(organizationId: string, type: ConfigServiceName): Promise<GetOrganizationConfigResponse> {
        const response = await bexHttpClient.get(`config/get-organization-config/${organizationId}/${type}`);
        return response;
    }

    /**
     * Update organization configuration details for a specific service type.
     * @param {string} organizationId - The organization ID.
     * @param {ConfigServiceName} type - The service type (elasticsearch, redis, or milvus).
     * @param {any} data - The configuration data to update.
     * @returns {Promise<UpdateOrganizationConfigResponse>} The response containing updated configuration details.
     * Note: Using 'any' because the update data structure varies by service type and isn't fully defined in the types file
     */
    async updateConfigDetails(organizationId: string, type: ConfigServiceName, data: any): Promise<UpdateOrganizationConfigResponse> {
        const response = await bexHttpClient.put(`config/update-organization-config/${organizationId}/${type}`, data);
        return response;
    }

    /**
     * Check elasticsearch deployment status for an organization.
     * @param {string} organizationId - The organization ID.
     * @returns {Promise<AxiosResponse<any>>} The response containing deployment status.
     * Note: Using 'any' because the deployment status response structure is not defined in the types file
     */
    async checkElasticsearchDeployment(organizationId: string): Promise<AxiosResponse<any>> {
        const response = await bexHttpClient.get(`admin/check-elasticsearch-deployment/${organizationId}`);
        return response;
    }

    /**
     * Check redis deployment status for an organization.
     * @param {string} organizationId - The organization ID.
     * @returns {Promise<AxiosResponse<any>>} The response containing deployment status.
     * Note: Using 'any' because the deployment status response structure is not defined in the types file
     */
    async checkRedisDeployment(organizationId: string): Promise<AxiosResponse<any>> {
        const response = await bexHttpClient.get(`admin/check-redis-deployment/${organizationId}`);
        return response;
    }

}

const secretKeysService = new SecretKeysService();
export { secretKeysService };